<template>
  <div class="qrCode">
    <div class="header">
      <div class="title">微信二维码登录</div>
      <div class="close-btn" @click="gotoLogin">
        <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
          <use xlink:href="#icon-arrow-left-circle"></use>
        </svg>
      </div>
    </div>
    <div v-if="!codeFailure" class="code-img" v-loading="loading">
      <img v-if="encodeLink" :src="encodeLink" alt="img" />
    </div>
    <div v-else class="qrcode1" @click="getQrcodeApi">
      <div>
        <img src="~@/assets/images/Refresh.svg" alt="" />
      </div>
    </div>
    <p v-if="!scanSuccess">扫码关注沸志科技公众号进行登录</p>
    <p v-else class="success">
      <img src="~@/assets/images/login-success.png" alt="" />
      <span>扫码成功</span>
    </p>
  </div>
</template>

<script>
import { getQrcode, loginState } from '@/api/login'
import { setToken } from '@/utils/auth'
import {
  switchTeam,
  teamListSelect
} from '@/api/teamManagement'

export default {
  data () {
    return {
      encodeLink: '',
      noncestr: '',
      loading: false,
      openId: '',
      scanSuccess: false,
      codeFailure: false,
      timer: null
    }
  },
  mounted () {
    this.getQrcodeApi()
  },
  destroyed () {
    this.timer && clearInterval(this.timer)
  },
  methods: {
    // 获取二维码
    async getQrcodeApi () {
      this.codeFailure = false
      this.loading = true
      const { data } = await getQrcode()
      this.encodeLink = data.qrCode
      this.noncestr = data.noncestr
      this.loading = false
      this.timer = setInterval(() => {
        this.loginStateApi()
      }, 2000)
    },

    // 查询登录状态
    async loginStateApi () {
      try {
        const { data } = await loginState(this.noncestr)
        if (data.openId !== null) {
          this.scanSuccess = true
          this.openId = data.openId
        }
        if (data.status === 'UN_BIND') {
          this.$emit('showBindingAccountMsg', data.openId)
        }
        if (data.access_token) {
          const token = data.token_type + ' ' + data.access_token
          setToken(token)
          const res = await teamListSelect()
          await switchTeam({ teamId: res.data[0].id })
          this.$router.push('/controlPlatform')
        }
      } catch (error) {
        this.codeFailure = true
        this.timer && clearInterval(this.timer)
      }
    },
    // 跳转登录
    gotoLogin () {
      this.$emit('showLoginMsg')
    }
  }
}
</script>

<style lang="scss" scoped>
.qrCode {
  position: absolute;
  right: 120px;
  top: 50%;
  transform: translateY(-50%);
  // width: 412px;
  // height: 520px;
  // box-shadow: 0 0 px 2px #4ea2c9;
  // border: 2px solid rgba(78, 162, 201, 0.8);
  // border-radius: 24px;
  // background-color: rgba(255, 255, 255, 0.13);
  backdrop-filter: blur(5px);
  text-align: center;

  width: 424px;
  height: 542px;
  background: url("~@/assets/images/bg2.png") no-repeat;
  background-size: contain;

  .header {
    position: relative;
    margin: 52px 0 41px 0;
  }
  .qrcode1 {
    margin: 50px auto;
    width: 200px;
    height: 200px;
    background: url('~@/assets/images/wechat-bg.jpg') no-repeat;
    background-size: cover;
    border-radius: 12px;
    cursor: pointer;
    div{
      width: 100%;
      height: 100%;
      line-height: 200px;
      border-radius: 12px;
      background: rgba(0, 0, 0, 0.7);
      img{
        width: 28px;
      }
    }
  }
  .code-img {
    margin: 50px auto;
    width: 200px;
    height: 200px;
    border-radius: 12px;
    overflow: hidden;
    > img {
      width: 200px;
      height: 200px;
      border-radius: 12px;
    }
  }
  .success {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      margin-right: 13px;
    }
  }
  .title {
    font-size: 24px;
    font-family: Source Han Sans SC;
    color: #ffffff;
    text-shadow: 0px 3px 9px rgba(93, 204, 255, 1),
      0px 2px 17px rgba(77, 199, 255, 1);
    text-align: center;
  }
  .close-btn {
    position: absolute;
    right: 6px;
    top: -47px;
    width: 47px;
    height: 47px;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba($color: #4d9fc6, $alpha: 0.5);
    box-shadow: 1px 2px 9px 1px rgba(0, 0, 0, 0.1);
    border-radius: 0px 24px 1px 24px;
    text-align: center;
    line-height: 57px;
    svg {
      font-size: 24px;
      color: #49b8ff;
      cursor: pointer;
    }
  }
}
</style>
